import {createBrowserRouter} from "react-router-dom";
import {DashboardRoute} from "~/components/Board";
import {NotFound} from "~/components/NotFound";

export const router = createBrowserRouter(
    [
        {
            path: "/",
            errorElement: <NotFound />,
            ...DashboardRoute
        },
        {
            path: "/:pin",
            errorElement: <NotFound />,
            ...DashboardRoute
        },
    ]
)